<template>
  <div class="stars">
    <BaseIcon
      v-for="i in max"
      :key="i"
      name="star"
      class="star"
      :class="{
        'star--active': i <= data,
        'star--hover': i <= hover,
        'star--disabled': disabled
      }"
      @click="setValue(i)"
      @mouseover.native="setHover(i)"
      @mouseleave.native="setHover(0)"
    />
  </div>
</template>

<script>
import BaseIcon from "../Elements/BaseIcon";
import BaseControl from "./BaseControl";

export default {
  name: "BaseStars",
  components: {
    BaseIcon
  },
  extends: BaseControl,
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      data: this.value,
      hover: 0
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      this.data = parseInt(newValue);
    }
  },
  methods: {
    setValue(i) {
      if (!this.disabled) {
        this.data = i;
        this.emitEvent(i);
      }
    },
    setHover(i) {
      if (!this.disabled) {
        this.hover = i;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
.stars {
  padding: 7px 0 0 0;
  height: calc(1.5em + 0.75rem + 2px);
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 150px;
}
.star {
  transition: all $transition-duration;
  font-size: 1.3em;
  fill: $col-polmed-gray;
  &--active {
    fill: $col-polmed-blue;
  }
  &--hover {
    fill: $col-polmed-navy;
  }
  &--disabled {
    fill: $col-polmed-gray;
  }
  &--active.star--disabled {
    fill: $col-polmed-gray2;
  }
}
</style>
